import api from './api';

export interface TaxContribution {
  id: string;
  userId: string;
  payslipId?: string;
  year: number;
  quarter: number;
  employeeTaxContribution: number;
  employeeSocialSecurityContribution: number;
  companySocialSecurityContribution: number;
  notes?: string;
  currency: string;
  createdAt: string;
  payPeriodStart?: string;
  payPeriodEnd?: string;
  employeeName?: string;
}

export interface QuarterlyTotal {
  year: number;
  quarter: number;
  currency: string;
  totalEmployeeTax: number;
  totalEmployeeSocialSecurity: number;
  totalCompanySocialSecurity: number;
  totalContributions: number;
  payrollRunsCount: number;
}

export interface ContributionFilters {
  year?: number;
  quarter?: number;
}

export const contributionsApi = {
  getAll: async (filters?: ContributionFilters): Promise<TaxContribution[]> => {
    const params = new URLSearchParams();
    if (filters?.year) params.append('year', filters.year.toString());
    if (filters?.quarter) params.append('quarter', filters.quarter.toString());

    const queryString = params.toString();
    const url = `/contributions${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data.data;
  },

  getQuarterlyTotals: async (year?: number): Promise<QuarterlyTotal[]> => {
    const params = new URLSearchParams();
    if (year) params.append('year', year.toString());

    const queryString = params.toString();
    const url = `/contributions/quarterly-totals${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data.data;
  },

  getById: async (id: string): Promise<TaxContribution> => {
    const response = await api.get(`/contributions/${id}`);
    return response.data.data;
  },
};
